var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAiGenerateGradientFilled = function SvgIconAiGenerateGradientFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_ai_generate_gradient_filled_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M3 3h18v18H3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ai_generate_gradient_filled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.814 9.046-2.437-.904a3.936 3.936 0 0 1-2.32-2.32l-.904-2.437a.59.59 0 0 0-1.107 0l-.904 2.437a3.936 3.936 0 0 1-2.32 2.32l-2.437.904a.59.59 0 0 0 0 1.107l2.437.904a3.935 3.935 0 0 1 2.32 2.32l.904 2.438a.59.59 0 0 0 1.107 0l.904-2.437a3.936 3.936 0 0 1 2.32-2.32l2.437-.905a.59.59 0 0 0 0-1.107Z",
    fill: "url(#icon_ai_generate_gradient_filled_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.787 17.033-1.352-.501a2.181 2.181 0 0 1-1.287-1.287l-.5-1.351a.327.327 0 0 0-.615 0l-.5 1.351a2.182 2.182 0 0 1-1.288 1.287l-1.351.501a.327.327 0 0 0 0 .614l1.351.501c.596.221 1.066.691 1.287 1.287l.501 1.352a.327.327 0 0 0 .614 0l.501-1.352a2.182 2.182 0 0 1 1.287-1.287l1.352-.501a.327.327 0 0 0 0-.614Z",
    fill: "url(#icon_ai_generate_gradient_filled_svg__c)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_ai_generate_gradient_filled_svg__b",
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#377CFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7D2DFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA38FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_ai_generate_gradient_filled_svg__c",
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#377CFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7D2DFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA38FB"
  })))));
};
export default SvgIconAiGenerateGradientFilled;